import { useCallback } from 'react';
import { allowedNotificationTypes, phoneNotificationTypes, tagNotificationsType } from '@frontend/settings-routing';
import {
  PopupDurationValues,
  SoundId,
  SoundSettings,
  TransientQueueProps,
  WeavePopNotification,
} from '@frontend/types';
import { usePreference } from '@frontend/user-preferences';

export const getSoundSettings = () => {
  const settings: Record<any, SoundId | ''> = {};
  [...allowedNotificationTypes, ...phoneNotificationTypes, ...tagNotificationsType].forEach((notification) => {
    settings[notification.type] = '';
  });
  return settings as SoundSettings;
};

export const useNotificationSettings = () => {
  const [notificationSettings, setNotificationSettings] = usePreference('NotificationSettings');
  const setManageAll = useCallback(
    (value: boolean): void => {
      setNotificationSettings({ ...notificationSettings, manageAll: value });
    },
    [notificationSettings]
  );

  const setNotificationSound = useCallback(
    ({ type, soundId }: { soundId: SoundId; type: WeavePopNotification['type'] }): void => {
      setNotificationSettings({
        ...notificationSettings,
        notificationSounds: { ...notificationSettings.notificationSounds, [type]: soundId },
      });
    },
    [notificationSettings]
  );

  const setDurationMs = useCallback(
    (durationMs: PopupDurationValues): void => {
      setNotificationSettings({
        ...notificationSettings,
        notificationSettings: { ...notificationSettings.notificationSettings, durationMs },
        hasChangedDuration: true,
      });
    },
    [notificationSettings]
  );

  const setPlacement = useCallback(
    (placement: TransientQueueProps['placement']): void => {
      setNotificationSettings({
        ...notificationSettings,
        notificationSettings: { ...notificationSettings.notificationSettings, placement },
      });
    },
    [notificationSettings]
  );

  return {
    notificationSettings: notificationSettings.notificationSettings,
    notificationSounds: notificationSettings.notificationSounds,
    manageAll: notificationSettings.manageAll,
    hasChangedDuration: notificationSettings.hasChangedDuration,
    setManageAll,
    setNotificationSound,
    setDurationMs,
    setPlacement,
  };
};
